<script>
import { BCarousel } from "bootstrap-vue";

export default {
  extends: BCarousel
};
</script>